import {Controller} from '@hotwired/stimulus';
import {useDirtyFormTracking, isDirty} from 'stimulus-library';
export default class extends Controller {

  static targets = [
    "form",
  ];

  declare formTarget: HTMLFormElement;
  connect() {
    useDirtyFormTracking(this, this.formTarget);
    window.addEventListener("beforeunload", this.beforeUnload);
    this.formTarget.addEventListener("submit", this.handleSubmit);
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.beforeUnload);
    this.formTarget.removeEventListener("submit", this.handleSubmit);
  }
  handleSubmit = () => {
    window.removeEventListener("beforeunload", this.beforeUnload);
  };

  beforeUnload = (event: BeforeUnloadEvent) => {
    if (!isDirty(this.formTarget)) return;

    event.preventDefault();
    event.returnValue = true;
  };
}

